import { render, staticRenderFns } from "./EmpresaView.vue?vue&type=template&id=35944a9e"
import script from "./EmpresaView.vue?vue&type=script&lang=js"
export * from "./EmpresaView.vue?vue&type=script&lang=js"
import style0 from "./EmpresaView.vue?vue&type=style&index=0&id=35944a9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports